import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Spacer,
  TranslationProvider,
} from '@resy/ui-kitchen';

import QuestionMark from '../../../images/icons/question.svg';

import './ReservationCancelError.scss';

const ReservationCancelError = ({
  closeModal,
}) => (
  <div className="ReservationCancelError">
    <div className="ReservationCancelError__content">
      <>
        <QuestionMark width={63} height={63} />
        <Spacer height={15} />
        <TranslationProvider translationKey="reservation_cancel_error_title">
          <h1
            className="ReservationCancelError__content-title"
            role="alert"
          >
            {'Something<br />Went Wrong'}
          </h1>
        </TranslationProvider>
        <TranslationProvider
          translationKey="reservation_cancel_error_content_p1"
        >
          <p>
            {`Did you already cancel? If not, take a look in<br />
            <a href="/account/reservations-and-notify">
              <strong>your Account</strong></a>.`}
          </p>
        </TranslationProvider>
        <Spacer height={50} />
        <TranslationProvider
          translationKey="reservation_cancel_error_content_p2"
        >
          <p>
            {`Please <a href="mailto:help@resy.com">
              <strong>email us</strong></a> if you have questions.`}
          </p>
        </TranslationProvider>
      </>
    </div>
    <div className="ReservationCancelError__ctas">
      <TranslationProvider translationKey="reservation_canceled_button">
        <Button
          lg
          onClick={closeModal}
          data-test-id="reservation_cancel_error-button-done"
        >
          Dismiss
        </Button>
      </TranslationProvider>
    </div>
  </div>
);

ReservationCancelError.propTypes = {
  closeModal: PropTypes.func,
};

ReservationCancelError.defaultProps = {
  closeModal: () => {},
};

export default ReservationCancelError;
